import React, { FC } from 'react';
import { alpha, Box, lighten, SxProps, Theme, Typography } from '@mui/material';
import DashboardMock from './dashboardMock.png';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

type Props = {
  onClick?: () => void;
  styles?: SxProps<Theme>;
};

const VideoPreview: FC<Props> = ({ styles = {}, onClick }) => {
  return (
    <Box
      component="span"
      display="flex"
      position="relative"
      sx={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      <Box
        component="img"
        src={DashboardMock}
        alt="Preview"
        sx={{
          maxWidth: ({ spacing }) => spacing(18.75),
          maxHeight: ({ spacing }) => spacing(10),
          flex: 1,
          objectFit: 'cover',
          filter: 'blur(0.5px)',
          border: ({ palette }) => `1px solid ${palette.dividerLight}`,
          borderRadius: '10px',
          ...styles,
        }}
      />
      <PlayCircleIcon
        color="primary"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: ({ spacing }) => spacing(5),
          height: ({ spacing }) => spacing(5),
          boxShadow: ({ shadows }) => shadows[5],
          borderRadius: '50%',
        }}
      />
      <Typography
        fontWeight={700}
        variant="body2"
        color="primary.dark"
        fontSize={11}
        sx={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          whiteSpace: 'nowrap',
          backgroundColor: ({ palette }) => lighten(palette.primary.light, 0.6),
          borderRadius: 10,
          padding: ({ spacing }) => spacing(0, 1),
          letterSpacing: '-0.25px',
        }}
      >
        3 דקות ולמדנו!
      </Typography>
    </Box>
  );
};

export default VideoPreview;
